import { render, staticRenderFns } from "./i-font-tester.vue?vue&type=template&id=33fbb362&scoped=true&"
import script from "./i-font-tester.vue?vue&type=script&lang=js&"
export * from "./i-font-tester.vue?vue&type=script&lang=js&"
import style0 from "./i-font-tester.vue?vue&type=style&index=0&id=33fbb362&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbb362",
  null
  
)

export default component.exports